import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorStylesByRecord } from 'PDF/helpers/documentStyle';

import { colorIndexesDevelopTimeLine } from './colors';

interface ILegendItemProps {
  info: string;
}

export const LegendItem: React.FC<ILegendItemProps> = ({ info }) => {
  const { t } = useTranslation();
  const [doneColor, inProgressColor, toDoColor] = getColorStylesByRecord(colorIndexesDevelopTimeLine);

  const backgroundColor = {
    backgroundColor:
      info === t('statuses.done') || info === 'Done'
        ? doneColor
        : info === t('statuses.inProgress') || info === 'In progress'
          ? inProgressColor
          : toDoColor,
  };

  return (
    <View style={styles.legendItemWrap}>
      <View style={[styles.color, backgroundColor]} />
      <Text style={styles.text}>{info}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  legendItemWrap: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginRight: '24.5px',
  },
  color: {
    height: '8px',
    width: '8px',
    marginRight: '4px',
  },
  text: {
    fontFamily: 'Noto',
    fontWeight: 400,
    fontSize: '8px',
    color: '#607772',
  },
});
